module.exports = __webpack_public_path__ + "img/20220415_101120.635e30c9.jpg";